import React from 'react';
import { css } from '@emotion/react';

import theme from "../../theme";
import { getPriceByInterval } from "../includes/stripePlansHelpers";

type Props = {
    isSelected: boolean,
    numberOfUsers: string,
    onPlanSelect: (plan: StripePlan) => void,
    plan: StripePlan,
    currencySymbol?: string,
};

const PlanSelectionItem: React.FC<Props> = ({
    isSelected,
    numberOfUsers,
    onPlanSelect,
    plan,
    currencySymbol,
}) => {
    const price = getPriceByInterval(plan, numberOfUsers);
    const numberOfMonths = (plan.Interval === 'month' ? 1 : 12) * parseInt(numberOfUsers);
    const totalPrice = price * numberOfMonths;

    return (
        <div css={containerStyle(isSelected)}  onClick={() => onPlanSelect(plan)}>
            <div css={intervalStyle}>
                {plan.Interval === 'month' ? 'monthly' : 'annual'}
            </div>
            <div css={priceStyle(isSelected)}>
                {currencySymbol}{price.toFixed(2)}
            </div>
            <div css={textStyle(isSelected)}>
                /mo/user
            </div>
            <div css={billingStyle}>
                {currencySymbol}{getBillingWording(plan.Interval, totalPrice)}
            </div>
        </div>
    )
};

const getBillingWording = (interval: string, totalPrice: number) => {
    return `${totalPrice.toFixed(2)} billed ${interval === 'month' ? 'monthly' : 'annually'}`;
};

const containerStyle = (isSelected: boolean) => css`
    margin-top: 40px;
    width: 48%;
    height: ${isSelected ? 160 : 165}px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-sizing: content-box;
    background: #efefef;

    ${ isSelected ? css`
        background-color: #06d02f;
        border: 3px solid #81f357;
        color: white;
    ` : css`
        &:hover {
            background-color: ${theme.colours.blue['50']};
        }
    `}

    

    ${theme.breakpoints.down('sm')} {
        width: 45%;
        max-width: 240px;
    }
`;

const intervalStyle = css`
    font-size: 16px;
    height: 26px;
`;

const priceStyle = (isSelected: boolean) => css`
    height: 40px;
    font-size: 32px;
    font-weight: 400;

    ${ isSelected && css`
        font-weight: 600;
    ` }

    ${theme.breakpoints.down('xs')} {
        font-size: 26px;
    }
`;

const textStyle = (isSelected: boolean) => css`
    font-size: 16px;
    font-weight: 400;
    height: 34px;

    ${ isSelected && css`
        font-weight: 600;
    ` }
`;

const billingStyle = css`
    font-size: 12px;
    font-style: italic;

    ${theme.breakpoints.down('xs')} {
        padding: 0 20px;
        text-align: center;
        height: 24px;
    }
`;

export default PlanSelectionItem;
